import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { jwtDecode } from 'jwt-decode';
import { getToken, getUserAccount } from '../services/repository/userPoliciesRepository';

const storageSync = {
  tokenKey: 'fopag.auth.token',
  redirectToLogin: () => {
    window.location.href = `${process.env.REACT_APP_LOGIN_API_URL}?returnUrl=${window.location.href}`;
  },
};

const redirecionarLogin = () => {
  localStorage.removeItem(storageSync.tokenKey);
  window.location.href = `${process.env.REACT_APP_LOGIN_APDATA_URL}?returnUrl=${window.location.origin}`;
};

const isTokenExpired = (token) => {
  const { exp } = jwtDecode(token);
  if (exp) {
    const currentTime = Math.floor(Date.now() / 1000) + 86400 - 5000;
    return currentTime > exp;
  }
  return true;
};

export const UserPolicyContext = createContext({});

export function UserPolicyProvider({ children }) {
  const [userAccount, setUserAccount] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        const token = await getToken();
        if (!token || isTokenExpired(token)) {
          redirecionarLogin();
          return;
        }

        const userAccountFound = await getUserAccount();

        if (isMounted) {
          setUserAccount(userAccountFound);
        }
      } catch (err) {
        redirecionarLogin();
        return;
      } finally {
        if (isMounted) setLoading(false);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  const isAdmin = () => Boolean(userAccount?.isBwgSupervisorOrAdmin);
  const isGestor = () => Boolean(userAccount && !userAccount.isBwgSupervisorOrAdmin);

  const value = useMemo(
    () => ({ userAccount, loading, isAdmin, isGestor, ability: userAccount?.ability }),
    [userAccount, loading]
  );

  return <UserPolicyContext.Provider value={value}>{children}</UserPolicyContext.Provider>;
}

UserPolicyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useUserPolicy = () => useContext(UserPolicyContext);
